import React from 'react';
import ArchitectHeader from './ArchitectHeader';

/** Engineer chrome — same header as Design Portal, labeled Engineer Work. */
const EngineerHeader: React.FC = () => (
  <ArchitectHeader
    homePath="/designer-portal"
    homeLinkLabel="Engineer Work"
    showStandup={false}
    showHours={false}
  />
);

export default EngineerHeader;
